import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table, Card } from 'antd';

import CustomerManagementPersonForm from '../../forms/CustomerManagementPersonForm';
import CustomerDocUpload from '../../components/CustomerDocUpload';
import { currencyFormat } from '../../utils/globals';

import QUERY from '../../graphql/queries/getCustomerManagementPersonsQuery.graphql';

const { Column } = Table;

const ManagementDetails = (props) => {
  const { loading, managementPersons } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }

  const customerId = props.match.params.id;
  let totalNetworth = 0;
  managementPersons.forEach((mp) => {
    totalNetworth += mp.networth;
  });

  return (
    <div>
      <h2 className="page-title">Factsheet - Management Team Details</h2>
      <Card title="View all persons" bordered={false} className="ec-card">
        <p><strong>Total Networth = </strong>{currencyFormat(totalNetworth)}</p>
        <Table dataSource={managementPersons} rowKey="id" pagination={false}>
          <Column
            title="Name"
            key="name"
            render={(text, record) => (<span>{`${record.first_name} ${record.middle_name} ${record.last_name}`}</span>)}
          />
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                {record.street_address}
                <br />
                {record.city}, {record.state} - {record.pincode}
              </span>
            )}
          />
          <Column
            title="Networth"
            dataIndex="networth"
            key="networth"
            render={(text) => currencyFormat(text)}
          />
          <Column
            title="Documents to be uploaded"
            key="documents"
            render={(text, record) => (
              <div>
                {
                  (record.pan_doc && !record.pan_doc.uploaded) ?
                    <div style={{ display: 'inline-block', marginRight: 10 }}>
                      <CustomerDocUpload task_id={record.pan_doc.task.id} customerDoc={record.pan_doc} customer_id={customerId} buttonText="PAN" />
                    </div>
                    :
                    null
                }
                {
                  (record.aadhaar_doc && !record.aadhaar_doc.uploaded) ?
                    <div style={{ display: 'inline-block', marginRight: 10 }}>
                      <CustomerDocUpload task_id={record.aadhaar_doc.task.id} customerDoc={record.aadhaar_doc} customer_id={customerId} buttonText="Aadhaar" />
                    </div>
                    :
                    null
                }
                {
                  (record.networth_doc && !record.networth_doc.uploaded) ?
                    <div style={{ display: 'inline-block', marginRight: 10 }}>
                      <CustomerDocUpload task_id={record.networth_doc.task.id} customerDoc={record.networth_doc} customer_id={customerId} buttonText="CA certified Networth" />
                    </div>
                    :
                    null
                }
              </div>
            )}
          />
        </Table>
      </Card>
      <Card title="Add new person" bordered={false} className="ec-card">
        <CustomerManagementPersonForm customer_id={customerId} />
      </Card>
    </div>
  );
};

ManagementDetails.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    managementPersons: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(ManagementDetails);



// WEBPACK FOOTER //
// ./src/pages/factsheet/ManagementDetails.jsx